var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 13.4794L9.27062 11.375L8.125 12.5206L11.375 15.7706L17.875 9.27062L16.7294 8.125L11.375 13.4794Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 24.375L7.98201 21.6994C6.55146 20.9384 5.35517 19.8021 4.5215 18.4126C3.68784 17.0232 3.24828 15.4329 3.25001 13.8125V3.25C3.25044 2.81916 3.42178 2.40608 3.72643 2.10143C4.03109 1.79677 4.44416 1.62543 4.87501 1.625H21.125C21.5558 1.62543 21.9689 1.79677 22.2736 2.10143C22.5782 2.40608 22.7496 2.81916 22.75 3.25V13.8125C22.7517 15.4329 22.3122 17.0232 21.4785 18.4126C20.6448 19.8021 19.4485 20.9384 18.018 21.6994L13 24.375ZM4.87501 3.25V13.8125C4.87366 15.1383 5.2334 16.4395 5.91563 17.5764C6.59785 18.7132 7.57679 19.6428 8.74738 20.2654L13 22.5331L17.2526 20.2662C18.4233 19.6436 19.4024 18.7138 20.0846 17.5768C20.7668 16.4398 21.1265 15.1385 21.125 13.8125V3.25H4.87501Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.23207d903055b612ca42219dd9c44614.svg";
export { ForwardRef as ReactComponent };